import "./Loading.scss";

interface ILoadingProps {isLoading:boolean}

const Loading = (props: ILoadingProps) => {


   if (props.isLoading) {
      return (
      <div className='loading-bg'>
         <div className="loading-spinner-container" role="alert">
            <span className="loading-spinner"></span>
            <span className="sr-only">Loading...</span>
         </div>
         
      </div>
      );
   }else{
      return null;
   }

};

export default Loading;
